import { render } from "./PropHeader.vue?vue&type=template&id=78431863&scoped=true"
import script from "./PropHeader.vue?vue&type=script&lang=js"
export * from "./PropHeader.vue?vue&type=script&lang=js"

import "./PropHeader.vue?vue&type=style&index=0&id=78431863&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78431863"]])

export default __exports__